import JoditEditor from './JoditEditor';

export default JoditEditor;


// WEBPACK FOOTER //
// ./src/index.js